export enum InvoiceOriginEnum {
  invoicing = 'invoicing',
  billing = 'billing',
  deposit = 'deposit'
}
